var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpdeskIconL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 18c0 5.523-4.477 10-10 10a9.98 9.98 0 01-7.761-3.694L7 25l1.585-3.622A9.982 9.982 0 018 18c0-5.523 4.477-10 10-10s10 4.477 10 10zm-15-3h10l1 1-1 1H13l-1-1 1-1zm6 4h-6l-1 1 1 1h6l1-1-1-1zm11 0c0 6.075-4.925 11-11 11-1.34 0-2.624-.24-3.812-.678A9.965 9.965 0 0022 32a9.98 9.98 0 007.761-3.694L33 29l-1.585-3.622A9.981 9.981 0 0032 22a9.965 9.965 0 00-2.678-6.81C29.76 16.377 30 17.66 30 19z",
    fill: "#fff"
  })));
}

export default SvgHelpdeskIconL;